import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="focus-restore"
//
// Puts keyboard focus back on the checked radio after the Turbo Frame around it
// is replaced. The cart's shipping estimate submits on `change` and swaps the
// whole frame, so the radio that fired the change no longer exists when the
// answer lands and focus falls to <body> — arrowing to the second carrier ended
// the keyboard walk through the list, every time.
//
// Two guards, and both are the difference between a fix and a new bug:
// `arm()` (bound to `change`, which bubbles from the radio) means a lazy
// frame's FIRST load never steals focus from the top of the page, and the
// activeElement check means a customer who has already moved on — Tab out of
// the CEP field triggers a reload too — is never yanked back here.
export default class extends Controller {
	connect() {
		this.armed = false;
	}

	arm() {
		this.armed = true;
	}

	restore() {
		const armed = this.armed;
		this.armed = false;
		if (!armed) return;
		if (document.activeElement && document.activeElement !== document.body) return;

		this.element.querySelector("input[type=radio]:checked")?.focus();
	}
}
